import { convertColorName, isDarkColor } from '../../utils/color.utils';
import { HeroBackground, HeroContentPosition, HeroSize } from './index';

const DEFAULT_INLINE_SPLIT_PCT = 40;

const getContentWidth = (
  stack: boolean,
  splitSize: number = DEFAULT_INLINE_SPLIT_PCT,
) => {
  if (stack) {
    return 'full';
  }
  return `${splitSize}%`;
};

const getFlexBreakpoint = (size: HeroSize) => {
  if (size === 'large') {
    return 'lg';
  }
  return 'md';
};

const getFlexDirection = (position: HeroContentPosition, overlay: boolean) => {
  if (overlay) {
    if (position === 'left') {
      return 'row';
    }
    return 'row-reverse';
  } else {
    if (position === 'left') {
      return 'row-reverse';
    }
    return 'row';
  }
};

const getContentBackgroundColor = (background: HeroBackground) => {
  return convertColorName(background);
};

const getContentBackgroundGradient = (
  background: HeroBackground,
  position: HeroContentPosition,
) => {
  const color = getContentBackgroundColor(background);
  const direction = position === 'right' ? 'to-l' : 'to-r';
  return `linear(${direction}, ${color}, 75%, rgb(0,0,0,0))"`;
};

const getContentTextColor = (background: HeroBackground) => {
  if (isDarkColor(background)) {
    return 'white';
  }
  return undefined;
};

const getHeight = (size: HeroSize) => {
  switch (size) {
    case 'small':
      return { base: '200px', sm: '250px', md: '300px', lg: '350px' };
    case 'medium':
      return { base: '200px', sm: '275px', md: '350px', lg: '450px' };
    case 'large':
      return { base: '200px', sm: '300px', md: '425px', lg: '550px' };
  }
};

export {
  getContentBackgroundColor,
  getContentBackgroundGradient,
  getContentTextColor,
  getContentWidth,
  getFlexBreakpoint,
  getFlexDirection,
  getHeight,
};
